/* unplugin-vue-components disabled */import script from "./championShow.vue?vue&type=script&lang=jsx"
export * from "./championShow.vue?vue&type=script&lang=jsx"

import "./championShow.vue?vue&type=style&index=0&id=3cb9f972&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cb9f972"]])

export default __exports__